import React from 'react'
import ErrorIcon from '@mui/icons-material/Error';
import { Alert, Typography } from '@mui/material';

const AlertError = ({ message, margin, ...props }) => {
  return (
        <Alert 
            severity="error" 
            icon={<ErrorIcon />} 
            sx={{  width: '100%', backgroundColor: '#FCE8DB', color: '#71192F', boxSizing: 'border-box', alignItems: "center", margin:{margin}}}
            {...props}
        >
            <Typography sx={{fontWeight: '500', fontSize: '1rem'}}>Error</Typography>
            <Typography sx={{fontWeight: '400', fontSize: '.875rem'}}>{ message }</Typography>
        </Alert>
  )
}

export default AlertError